<template lang="pug">
 .b2b-pagedelivery-note-emits
    ods-module.box-card
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("recadv.recadv_detail.create_invoice_buttons_tooltip")', placement='bottom')
                  ods-button(
                    v-show='(canCreateInvoiceDeliveryNote && deliveryStatus !== "REJECTED" && deliveryStatus !== "ERROR" && deliveryStatus !== "FULLY_INVOICED")',
                    type='primary',
                    icon='ods-icon-plus',
                    size='small',
                    circle,
                    @click.native='handleCreateInvoice')
                    | {{ $t('recadv.recadv_detail.create_invoice_buttons') }}
              ods-tooltip(:content='$t("deliverynote.deliverynote_detail.download_pdf_buttons_tooltip")', placement='bottom')
                  ods-button(
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadDeliveryNotePdf')
                    | {{ $t('deliverynote.deliverynote_detail.download_pdf_buttons') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_original_signed_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canViewDesadvOriginal && deliveryNoteDetailForm.pathDeliveryNoteOriginal'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadOriginal')
                    | {{ $t('invoice_detail.buttons.download_original_signed') }}
              ods-tooltip(:content='$t("invoice_detail.buttons.download_metadata_tooltip")', placement='bottom')
                  ods-button(
                    v-show='canViewDesadvMetadata && deliveryNoteDetailForm.pathDeliveryMetadata'
                    type='primary',
                    icon='ods-icon-download',
                    size='small',
                    circle,
                    @click.native='handleDownloadMetadata')
                    | {{ $t('invoice_detail.buttons.download_metadata') }}
              ods-tooltip(:content='$t("buttons.btnDownloadLabels")', placement='bottom')
                ods-button(
                  v-show='deliveryNoteDetailForm.hasLabels'
                  type='primary',
                  icon='ods-icon-download',
                  size='small',
                  circle,
                  @click.native='handleDownloadLabels')
                  | {{ $t('invoice_detail.buttons.download_labels') }}
    ods-module.collapse
      ods-accordion(v-model='activateDetail', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('msg_generics.detail') }}

          ods-form(
            ref='deliveryNoteDetailForm',
            :model='deliveryNoteDetailForm',
            :rules='deliveryNoteDetailFormRules',
            label-width='14rem',
            label-position='top',
            size='small',
            status-icon)
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                    prop='sellerName',
                    :label='$t("deliverynote.delivery_entity_table.seller")'
                    style='margin-top: 0px;')
                    ods-input(
                      readonly,
                      v-model='deliveryNoteDetailForm.sellerName')
            ods-table(
              :data='deliveryNoteDetailForm.sellerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item.moreSpace(
                  prop='buyerName',
                  :label='$t("deliverynote.delivery_entity_table.buyer")')
                  ods-input(
                    readonly,
                    v-model='deliveryNoteDetailForm.buyerName')
            ods-table(
              :data='deliveryNoteDetailForm.buyerCentres'
              style='width: 100%',
              highlight-current-row,
              size='mini',
              fit)
              ods-table-column(
                prop='code',
                width='160'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.code.label")')
              ods-table-column(
                prop='description',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.name.label")')
              ods-table-column(
                prop='centreRoleTypeCode',
                width='190'
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.role.label")',
                :formatter='formatterRole')
              ods-table-column(
                prop='address',
                :label='$t("new_invoice.extension.faceb2b.dialog_add_centre.address.label")')
            ods-row(type='flex')
              ods-col(:span='6')
                ods-form-item(
                  prop='deliveryNumber',
                  :label='$t("invoices.filters.delivery_note.value")')
                  ods-input(
                    readonly,
                    v-model='deliveryNoteDetailForm.deliveryNumber')
              ods-col(:span='6')
                ods-form-item(
                  prop='orderNumber',
                  :label='$t("deliverynote.delivery_entity_table.order_number")')
                  ods-input(
                    v-if='deliveryNoteDetailForm.orderNumber',
                    readonly,
                    v-model='deliveryNoteDetailForm.orderNumber')
              ods-col(:span='6')
                ods-form-item(
                  prop='status',
                  :label='$t("deliverynote.delivery_entity_table.status")')
                  ods-input(
                    readonly,
                    v-model='deliveryNoteDetailForm.status')
              ods-col(:span='6')
                ods-form-item(
                  prop='status',
                  :label='$t("deliverynote.delivery_entity_table.delivery_type")')
                  ods-input(
                    readonly,
                    :value='$t("delivery_note_type." + deliveryNoteDetailForm.deliveryNoteTypeCode)')
            ods-row(type='flex')
              ods-col(:span='6')
                ods-form-item(
                  prop='issueDateTime',
                  :label='$t("deliverynote.delivery_entity_table.date_issue")')
                  ods-input(
                    readonly,
                    v-model='issueDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='creationDateTime',
                  :label='$t("deliverynote.delivery_entity_table.date_creation")')
                  ods-input(
                    readonly,
                    v-model='creationDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='deliveryDate',
                  :label='$t("deliverynote.delivery_entity_table.delivery_date")')
                  ods-input(
                    readonly,
                    v-model='deliveryDateTimeFormatted')
              ods-col(:span='6')
                ods-form-item(
                  prop='receptionMethod',
                  :label='$t("invoices.filters.communication_method.reception.value")')
                  ods-input(
                    readonly,
                    v-model='receptCommMethodFormatted')
            ods-row(type='flex')
              ods-col(:span='24')
                ods-form-item(
                  :label='$t("deliverynote.delivery_entity_table_detail.notes")',
                  prop='notes')
                  ods-input(
                    type='textarea',
                    readonly,
                    v-model='deliveryNoteDetailForm.notes')
            ods-row(type='flex')
              ods-col(:span='4')
                ods-form-item(
                  v-if='canChangeStatusDeliveryNote',
                  :label='$t("deliverynote.deliverynote_detail.change_state.label")',
                  prop='statusCode')
                  ods-select(
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='deliveryNoteDetailForm.statusCode',
                    :disabled='!canChangeStatusDeliveryNote'
                    filterable,
                    clearable,
                    :placeholder='$t("deliverynote.deliverynote_detail.change_state.placeholder")'
                    @change='changeStatus')
                    ods-option(
                      v-for='option in optionsFilterStatusDelivery',
                      :key='option.id',
                      :label='$t("deliverynote_status." + option.code)',
                      :value='option.code')
              ods-col(:span='2')
              ods-col(:span='16')
                ods-form-item(
                  v-if='canChangeStatusDeliveryNote && deliveryNoteDetailForm.statusCode'
                  :label='$t("invoice_detail.invoice_detail_edit_form.observations")',
                  prop='observations')
                  ods-input(v-model='deliveryNoteDetailForm.observations')

    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('deliverynote.deliverynote_detail.deliverynote_lines') }}
            span.info(v-show='!deliveryNotesEmitLine.length') {{ $t('deliverynote.deliverynote_detail.deliverynote_line_no_date') }}

          //- Tabla lineas albarán
          ods-table(
            v-if='deliveryNotesEmitLine.length > 0 ',
            :data='deliveryNotesEmitLine',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            @selection-change='handleSelectionChange',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              type='selection',
              width='55')
            ods-table-column(
            prop='lineNumber',
            :label='$t("deliverynote.delivery_entity_table_detail.lineNumber")',
            sortable='')
            ods-table-column(
              prop='itemCode',
              v-if='isShowItemCodeLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.itemCode")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='itemCodeSeller',
              width='155'
              v-if='isShowItemCodeSellerLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.itemCodeSeller")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='itemCodeBuyer',
              width='160'
              v-if='isShowItemCodeBuyerLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.itemCodeBuyer")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='gtin14Code',
              width='160'
              v-if='isShowGtin14LinesDeliveryNoteEmit',
              :label='$t("deliverynote.delivery_entity_table_detail.gtin14Code")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='codeCentreDeliveryPoint',
              width='160'
              v-if='isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.codeCentreDeliveryPoint")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='description',
              v-if='isShowDescriptionLinesDeliveryNoteEmit'
              width='260'
              :label='$t("deliverynote.delivery_entity_table_detail.description")',
              :show-overflow-tooltip='true')
            ods-table-column(
              prop='orderNumber',
              v-if='isShowOrderLinesDeliveryNoteEmit'
              width='130'
              :label='$t("deliverynote.delivery_entity_table_detail.order")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='serialNumber',
              v-if='isShowSerialNumberLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.serialNumber")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='batch',
              v-if='isShowBatchLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.batch")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='150'
              prop='expirationDate',
              v-if='isShowExpirationDateLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.expirationDate")',
              :show-overflow-tooltip='true',
              :formatter='dateFormatted',
              sortable)
            ods-table-column(
              prop='quantity',
              v-if='isShowQuantityLinesDeliveryNoteEmit'
              align='right',
              :label='$t("deliverynote.delivery_entity_table_detail.quantity")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='measure',
              v-if='isShowMeasureLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.measure")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='quantityTradeUnit',
              v-if='isShowQuantityTradeUnitLinesDeliveryNoteEmit'
              align='right',
              :label='$t("deliverynote.delivery_entity_table_detail.quantityTradeUnit")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='unitOfMeasureTradeUnit',
              v-if='isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.measureTradeUnit")',
              :show-overflow-tooltip='true')
            ods-table-column(
              width='130'
              prop='status',
              v-if='isShowStatusLinesDeliveryNoteEmit'
              :label='$t("deliverynote.delivery_entity_table_detail.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatus')
            ods-table-column(
              :render-header='renderHeaderActions',
              width='120')
    ods-row.form-actions
      ods-col(:span='24')
        ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
          ods-button(
            v-if='canChangeStatusDeliveryNote'
            type='primary',
            size='large'
            @click='submitDeliveryNoteDetailEditForm')
            | {{ $t('buttons.btnSaveChanges') }}
        ods-tooltip(:content='$t("buttons.btnClear")', placement='bottom')
          ods-button(
            v-if='canChangeStatusDeliveryNote'
            ref='buttonCancel',
            size='large'
            type='neutral',
            @click='cancelDeliveryNoteDetailEditForm')
            | {{ $t('buttons.btnClear') }}

    ods-module.collapse
      ods-accordion(v-model='activateRelatedDocuments', @change='')
        ods-accordion-item(
          name='1')
          template(slot='title')
            span {{ $t('deliverynote.deliverynote_detail.source_related_documents') }}
            span.info(v-show='!sourceRelatedDocuments.length') &nbsp;&nbsp;&nbsp;{{ $t('deliverynote.deliverynote_detail.related_documents_no_data') }}
          //- Tabla documentos relacionados de origen
          ods-table(
            v-if='sourceRelatedDocuments.length > 0 ',
            :data='sourceRelatedDocuments',
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='idSourceDocument',
              :label='$t("deliverynote.delivery_related_documents_table.destinationDocument")')
              template(slot-scope='scope')
                span(v-if='scope.row.idSourceDocument')
                a(
                  @click='goToDetail(scope.row.idSourceDocument, scope.row.sourceDocumentType, scope.row.emissionSourceDocument)',
                  style='color: var(--color-bg-interactive); cursor: pointer;'
                )
                  | {{ scope.row.sourceDocumentNumber }}
            ods-table-column(
              prop='sourceDocumentType',
              :label='$t("deliverynote.delivery_related_documents_table.destinationDocumentType")')
              template(slot-scope='scope')
                span(v-if="scope.row.sourceDocumentType === 'INVOICE'") {{ $t('document_type.INVOICE') }}
                span(v-else-if="scope.row.sourceDocumentType === 'PURCHASEORDER'") {{ $t('document_type.PURCHASEORDER') }}
                span(v-else-if="scope.row.sourceDocumentType === 'DELIVERYNOTE'") {{ $t('document_type.DELIVERYNOTE') }}
                span(v-else-if="scope.row.sourceDocumentType === 'RECEIVEADVICE'") {{ $t('document_type.RECEIVEADVICE') }}
                span(v-else) {{ scope.row.sourceDocumentType }}
            ods-table-column(
              prop='creationDateTime'
              :label='$t("deliverynote.delivery_related_documents_table.date")',
              :formatter='relatedDocumentsdateFormatted')
        ods-accordion-item(
          name='2')
          template(slot='title')
            span {{ $t('deliverynote.deliverynote_detail.destination_related_documents') }}
            span.info(v-show='!destinationRelatedDocuments.length') {{ $t('deliverynote.deliverynote_detail.related_documents_no_data') }}
          //- Tabla documentos relacionados de destino
          ods-table(
            v-if='destinationRelatedDocuments.length > 0 ',
            :data='destinationRelatedDocuments',
            style='width: 100%',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='idDestinationDocument',
              :label='$t("deliverynote.delivery_related_documents_table.destinationDocument")')
              template(slot-scope='scope')
                span(v-if='scope.row.idDestinationDocument')
                a(
                  @click='goToDetail(scope.row.idDestinationDocument, scope.row.destinationDocumentType, scope.row.emissionDestinationDocument)',
                  style='color: var(--color-bg-interactive); cursor: pointer;'
                )
                  | {{ scope.row.destinationDocumentNumber }}
            ods-table-column(
              prop='destinationDocumentType',
              :label='$t("deliverynote.delivery_related_documents_table.destinationDocumentType")')
              template(slot-scope='scope')
                span(v-if="scope.row.destinationDocumentType === 'INVOICE'") {{ $t('document_type.INVOICE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'PURCHASEORDER'") {{ $t('document_type.PURCHASEORDER') }}
                span(v-else-if="scope.row.destinationDocumentType === 'DELIVERYNOTE'") {{ $t('document_type.DELIVERYNOTE') }}
                span(v-else-if="scope.row.destinationDocumentType === 'RECEIVEADVICE'") {{ $t('document_type.RECEIVEADVICE') }}
                span(v-else) {{ scope.row.destinationDocumentType }}
            ods-table-column(
              prop='creationDateTime'
              :label='$t("deliverynote.delivery_related_documents_table.date")',
              :formatter='relatedDocumentsdateFormatted')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import B2bTableLinesDeliveryNotesEmit from '@/views/albaranes/emitidos/B2bTableLinesDeliveryNotesEmit'
import router from '@/router/index'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-pagedelivery-note-emits',
  mixins: [Utils],
  data () {
    return {
      activateLines: ['1'],
      activateDetail: ['1'],
      activateRelatedDocuments: ['1', '2'],
      sourceRelatedDocuments: [],
      destinationRelatedDocuments: [],
      deliveryNotesEmitLine: [],
      deliveryNotesEmitLineOriginal: [],
      statusDocumentDelivery: null,
      deliveryStatus: null,
      measureUnit: '',
      searchType: 'EMITTED',
      multipleSelection: [],
      dialogNewLineDeliveryNoteForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null
      },
      deliveryNoteDetailForm: {
        buyerName: null,
        sellerName: null,
        deliveryNumber: null,
        issueDateTime: '',
        creationDateTime: '',
        documentStatus: null,
        projectName: null,
        status: null,
        statusCode: null,
        deliveryNoteTypeCode: null,
        observations: null
      },

      viewUpdate: false,

      deliveryLineChanged: {
        id: null,
        idDeliveryNote: null,
        status: null,
        lineNumber: null,
        itemCode: null,
        quantity: null,
        unitPrice: null,
        totalAmount: null,
        documentStatus: null
      },

      currentRow: {},
      deliveryLinesChanged: [],
      isShowDialogCheckLine: false,
      isShowDialogCheckLineEdit: false,
      rulesdialogNewLineDeliveryNoteForm: {
        description: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        },
        {
          max: 50,
          message: this.$t('validations.maxlenght', { maxlenght: 256 }),
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        }],
        priceUnit: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        }]
      },
      rulesDialogNewLineEditDeliveryNoteForm: {
        description: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        },
        {
          max: 50,
          message: this.$t('validations.maxlenght', { maxlenght: 256 }),
          trigger: 'change'
        }],
        quantity: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        }],
        priceUnit: [{
          required: true,
          message: this.$t('deliverynote.deliverynote_detail.dialog_new_check_line_deliverynote.date_required'),
          trigger: 'change'
        }]
      },
      optionsMeasure: [],
      searchMeasure: [],
      dialogNewLineEditDeliveryNoteForm: {
        description: null,
        quantity: '',
        priceUnit: '',
        measure: null,
        deliveryIdLine: null
      }
    }
  },

  components: {
    B2bTimeline,
    B2bTableLinesDeliveryNotesEmit
  },

  computed: {
    ...mapGetters([
      'optionsFilterStatusDelivery',
      'isShowItemCodeLinesDeliveryNoteEmit',
      'isShowItemCodeSellerLinesDeliveryNoteEmit',
      'isShowItemCodeBuyerLinesDeliveryNoteEmit',
      'isShowGtin14LinesDeliveryNoteEmit',
      'isShowCodeCentreDeliveryPointLinesDeliveryNoteEmit',
      'isShowDescriptionLinesDeliveryNoteEmit',
      'isShowOrderLinesDeliveryNoteEmit',
      'isShowStatusLinesDeliveryNoteEmit',
      'isShowQuantityLinesDeliveryNoteEmit',
      'isShowMeasureLinesDeliveryNoteEmit',
      'isShowUnitOfMeasureTradeUnitLinesDeliveryNoteEmit',
      'isShowQuantityTradeUnitLinesDeliveryNoteEmit',
      'isShowSerialNumberLinesDeliveryNoteEmit',
      'isShowExpirationDateLinesDeliveryNoteEmit',
      'isShowItemCodeBuyerLinesDeliveryNoteEmit',
      'isShowBatchLinesDeliveryNoteEmit',
      // Permisos
      'canChangeStatusDeliveryNote',
      'canCreateInvoiceDeliveryNote',
      'canViewDesadvMetadata',
      'canViewDesadvOriginal'
    ]),
    // Formatear metodo de envio
    receptCommMethodFormatted (row, column) {
      if (this.deliveryNoteDetailForm.receptionMethod) {
        const receptValue = this.deliveryNoteDetailForm.receptionMethod
        return this.$t('communication_method.' + receptValue)
      } else return ''
    },
    issueDateTimeFormatted () { // eslint-disable-line
      if (this.deliveryNoteDetailForm.issueDateTime) {
        const date = moment(this.deliveryNoteDetailForm.issueDateTime)
        return date.format(this.$t('date_format'))
      }
    },
    creationDateTimeFormatted () { // eslint-disable-line
      if (this.deliveryNoteDetailForm.creationDateTime) {
        const date = moment(this.deliveryNoteDetailForm.creationDateTime)
        return date.format(this.$t('date_format_long'))
      }
    },
    deliveryDateTimeFormatted () { // eslint-disable-line
      if (this.deliveryNoteDetailForm.deliveryDate) {
        const date = moment(this.deliveryNoteDetailForm.deliveryDate)
        return date.format(this.$t('date_format_long'))
      }
    },
    deliveryNoteDetailFormRules () {
      const checkObservations = (rule, value, callback) => {
        const self = this
        const estado = this.optionsFilterStatusDelivery.find(function (t) {
          return t.code === self.deliveryNoteDetailForm.statusCode
        })
        const observations = this.deliveryNoteDetailForm.observations
        if (estado && estado.code === 'REJECTED' && !observations) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }
      return {
        observations: [
          { max: 256, message: this.$t('msg_generics.max_num_character', { max: 256 }), trigger: 'blur' },
          { validator: checkObservations, trigger: 'blur, change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'modifyDeliveryNote',
      'getDeliveryNoteDetail',
      'getRelatedDocumentsDeliveryNote',
      'downloadDeliveryNotePdf',
      'downloadDeliveryOriginal',
      'downloadDeliveryMetadata',
      'downloadDeliveryNoteLabels',
      'getDeliveryNotesMeasure',
      'createInvoiceState'
    ]),

    changeStatus (data) {
      this.optionsFilterStatusDelivery.find(function (t) {
        return t.id === data
      })
      this.$refs.deliveryNoteDetailForm.clearValidate()
    },

    saveChanges (row) {
      this.viewUpdate = true
      const length = this.deliveryLinesChanged.length
      if (length > 0) {
        let comp = false
        for (let i = 0; i < length; i++) {
          const deliveryLineChangedAux = this.deliveryLinesChanged[i]
          if (deliveryLineChangedAux.id === row.id) {
            comp = true
            this.deliveryLinesChanged[i] = row
            i = length
          }
        }
        if (comp === false) {
          this.deliveryLinesChanged.push(row)
        }
      } else {
        this.deliveryLinesChanged.push(row)
      }
      // console.log('deliveryLinesChangedSALIDA: ', this.deliveryLinesChanged)
    },

    submitDeliveryNoteDetailEditForm () {
      const deliveryId = this.$route.params.deliveryId
      this.$refs.deliveryNoteDetailForm.validate(async (valid) => {
        if (valid && deliveryId != '_blank') {// eslint-disable-line
          const load = this.$loading({
            lock: true,
            text: this.$t('deliverynote.deliverynote_detail.change_state.load')
          })
          console.log('submitDeliveryNoteDetailEditForm: ', this.deliveryNoteDetailForm)
          try {
            const dataQuery = {
              query: {
                statusCode: this.deliveryNoteDetailForm.statusCode,
                observations: this.deliveryNoteDetailForm.observations
              }
            }
            const params = {
              deliveryId: deliveryId,
              dataQuery: dataQuery,
              searchType: this.searchType
            }
            await this.modifyDeliveryNote(params)
            this.$refs.deliveryNoteDetailForm.clearValidate()
            this.deliveryNoteDetailForm.status = this.$t('deliverynote_status.' + this.deliveryNoteDetailForm.statusCode)
            const length = this.deliveryNotesEmitLine.length
            if (length > 0) {
              for (let i = 0; i < length; i++) {
                this.deliveryNotesEmitLine[i].status = this.deliveryNoteDetailForm.statusCode
              }
            }
            this.deliveryNoteDetailForm.statusCode = null
            this.deliveryNoteDetailForm.observations = null

            this.$notify({
              title: this.$t('deliverynote.deliverynote_detail.notify.submit_edit_deliverynote_ok'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              duration: 10000
            })
          } catch (error) {
            console.log('submitDeliveryNoteDetailEditForm CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.$refs.deliveryNoteDetailForm.resetFields()
          } finally {
            load.close()
          }
        } else {
          console.log('submitDeliveryNoteDetailEditForm: ', this.deliveryNoteDetailForm)
          return false
        }
      })
    },

    async cancelDeliveryNoteDetailEditForm () {
      this.$refs.buttonCancel.$el.blur()
      this.deliveryNoteDetailForm.statusCode = null
      this.deliveryNoteDetailForm.observations = null
    },

    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    renderHeaderActions: h => {
      return <B2bTableLinesDeliveryNotesEmit />
    },
    formatterRole (row, column) {
      if (row[column.property]) {
        return this.$t('centre_role_type_order.' + row[column.property])
      }
      return ''
    },
    dateHourFormatted (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },
    dateFormatted (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    relatedDocumentsdateFormatted (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },
    cancelChanges () {
      this.viewUpdate = false
      this.deliveryLinesChanged = []
      this.resetBorderColor()
      // this.getDeliveryNotesLinesEmitOnDatabase()
    },

    // Documentos relacionados. Parameter 'type' = 'SEARCH_DESTINATION_DOCUMENTS' or 'SEARCH_SOURCE_DOCUMENTS'
    async getRelatedDocumentsOnDatabase (type) {
      try {
        if (this.$route.params.deliveryId && this.$route.params.deliveryId !== 'creacion') {
          const dataQuery = {
            query: {
              searchType: this.searchType,
              sourceDestinationType: type,
              deliveryId: this.$route.params.deliveryId
            }
          }
          const response = await this.getRelatedDocumentsDeliveryNote(dataQuery)
          if (type === 'SEARCH_SOURCE_DOCUMENTS') {
            this.sourceRelatedDocuments = response.data
          }
          if (type === 'SEARCH_DESTINATION_DOCUMENTS') {
            this.destinationRelatedDocuments = response.data
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Enlace al detalle del documento y tipo de documento
    async goToDetail (documentId, documentType) {
      console.log('Go to detail: ', documentId)
      console.log('Go to document type: ', documentType)
      if (documentType === 'DELIVERYNOTE') {
        router.push({
          name: 'delivery-note-emit-detail',
          params: {
            deliveryId: documentId
          }
        })
      } else if (documentType === 'INVOICE') {
        router.push({
          name: 'factura-emitida-detail',
          params: {
            invoiceNoteId: documentId
          }
        })
      } else if (documentType === 'PURCHASEORDER') {
        router.push({
          name: 'order-received-detail',
          params: {
            orderId: documentId
          }
        })
      } else if (documentType === 'RECEIVEADVICE') {
        router.push({
          name: 'recadv-received-detail',
          params: {
            recadvId: documentId
          }
        })
      }
    },

    resetBorderColor () {
      // get element by class
      const arr = document.getElementsByClassName('ods-button ods-tooltip bordered')

      // store length in variable
      // some say accessing .length in a loop condition adds overhead
      const arrLen = arr.length

      // loop through all found elements
      for (let i = 0; i < arrLen; i++) {
        if (arr[i].style) {
          arr[i].style.border = ''
        }
      }
    },
    formatterStatus (row, column) {
      return row.status != null ? this.$t('deliverynote_status.' + row.status) : null
    },
    formatterDecimal (row, column) {
      if (row[column.property] == null) {
        return this.$t('msg_generics.no_price')
      } else if (row[column.property] || row[column.property] == 0) { // eslint-disable-line
        return this.$n(row[column.property], 'decimal')
      }
      return ''
    },
    formatterQuantity (row, column) {
      if (row[column.property]) {
        return this.$n(row[column.property], 'three_decimal')
      }
      return ''
    },
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    // Creación de una factura
    async handleCreateInvoice () {
      if (this.$route.params.deliveryId && this.$route.params.deliveryId !== 'creacion') {
        let createInvoice = true
        console.log('multipleSelection', this.multipleSelection)
        // comprobamos que las lineas no estén rechazadas ni facturadas
        if (this.multipleSelection.length > 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            if (this.multipleSelection[0].status === 'REJECTED' || this.multipleSelection[0].status === 'FULLY_INVOICED') {
              createInvoice = false
            }
          }
        }
        if (!createInvoice) {
          await this.$notify({
            title: this.$t('order.order_detail.notify.line_error'),
            type: 'error',
            position: 'top-right',
            customClass: 'b2b-notification-error',
            duration: 10000
          })
        } else {
          const invoice = {
            deliveryId: this.$route.params.deliveryId,
            lineListIds: this.multipleSelection.map(item => item.id)
          }
          await this.createInvoiceState(invoice)
          router.push({ name: 'creacion-factura-albaranes-emitidos', query: { type: 'DELIVERYNOTE_EMIT' } })
        }
      }
    },
    // Descarga de pdf
    async handleDownloadDeliveryNotePdf () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          deliveryId: this.$route.params.deliveryId,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryNotePdf(params)
        this.$notify({
          title: this.$t('order.order_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadOriginal () {
      console.log('handleDownloadOriginal: ', this.$route.params.deliveryId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_invoice_original')
      })
      try {
        const params = {
          deliveryId: this.$route.params.deliveryId,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryOriginal(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadOriginal CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async handleDownloadMetadata () {
      console.log('handleDownloadMetadata: ', this.$route.params.deliveryId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_metadata')
      })
      try {
        const params = {
          deliveryId: this.$route.params.deliveryId,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryMetadata(params)
        this.$notify({
          title: this.$t('msg_generics.download_metadata_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadMetadata CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descargar etiquetas del albarán
    async handleDownloadLabels () {
      console.log('handleDownloadLabels: ', this.$route.params.deliveryId)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          deliveryId: this.$route.params.deliveryId,
          searchType: this.searchType
        }
        const filename = await this.downloadDeliveryNoteLabels(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Detalle Albarán
    async getDeliveryNotesEmitOnDatabase () {
      try {
        this.deliveryNoteDetailForm = await this.getDeliveryNoteDetail({
          deliveryId: this.$route.params.deliveryId,
          searchType: this.searchType
        })
        this.deliveryNotesEmitLine = this.deliveryNoteDetailForm.lines
        this.deliveryNotesEmitLineOriginal = this.deliveryNotesEmitLine
        // Guardamos estado
        this.deliveryStatus = this.deliveryNoteDetailForm.status
        this.statusDocumentDelivery = this.deliveryNoteDetailForm.documentStatus
        // Formateamos estado
        if (this.deliveryStatus != null && this.deliveryStatus === 'REJECTED' && this.deliveryNoteDetailForm.rejectSeller) {
          const REJECTED_SELLER = 'REJECTED_SELLER'
          this.deliveryNoteDetailForm.status = this.$t('deliverynote_status.' + REJECTED_SELLER)
        } else {
          this.deliveryNoteDetailForm.status = this.$t('deliverynote_status.' + this.deliveryNoteDetailForm.status)
          console.log(this.deliveryNoteDetailForm)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      // Detalle albarán
      await this.getDeliveryNotesEmitOnDatabase()
      await this.getRelatedDocumentsOnDatabase('SEARCH_SOURCE_DOCUMENTS')
      await this.getRelatedDocumentsOnDatabase('SEARCH_DESTINATION_DOCUMENTS')
      console.log('Estado del albarán ', this.deliveryStatus)
      console.log('canCreateInvoiceDeliveryNote', this.canCreateInvoiceDeliveryNote)
      console.log('(canCreateInvoiceDeliveryNote && deliveryStatus !== "REJECTED" && deliveryStatus !== "FULLY_INVOICED")', (this.canCreateInvoiceDeliveryNote && this.deliveryStatus !== 'REJECTED' && this.deliveryStatus !== 'ERROR' && this.deliveryStatus !== 'FULLY_INVOICED'))
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-pagedelivery-note-emits {
  ::v-deep .ods-input__inner {
    background-color: transparent !important;
  }
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 0px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .moreSpace {
    margin-bottom: 0px;
  }
  .ods-form-item {
    margin-bottom: 0px;
    margin-top: 1rem;
  }
  ::v-deep .ods-form-item__label {
    font-weight: 500;
  }

  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse{
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table{
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row{
        .ods-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
      ::v-deep .ods-button{
      background-color: #FFF;
      border-color: #FFF;
      color: #000;
      }
      ::v-deep .ods-input-number .ods-input__inner {
        padding: 4px 30px 4px 8px;
        text-align: right;
      }
    }
    ::v-deep .ods-input.is-disabled .ods-input__inner{
      background-color: transparent;
      border-color: transparent;
      color: black;
      cursor: not-allowed;
      text-align: right;
    }
    ::v-deep .ods-scrollbar__bar.is-horizontal, .ods-scrollbar__bar.is-horizontal {
      opacity: 1;
    }
    ::v-deep .ods-scrollbar__wrap.ods-table__body-wrapper {
      margin-bottom: 20px;
    }
    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
    ::v-deep .ods-date-editor.ods-input {
        width: 120px;
        margin-right: 24px;
      }
  }
  ::v-deep.ods-table__body-wrapper {
    margin-bottom: 20px !important;
  }
}
</style>
